import { render, staticRenderFns } from "./AttendanceSampleConfig.vue?vue&type=template&id=3731aef8&scoped=true"
import script from "./AttendanceSampleConfig.vue?vue&type=script&lang=js"
export * from "./AttendanceSampleConfig.vue?vue&type=script&lang=js"
import style0 from "./AttendanceSampleConfig.vue?vue&type=style&index=0&id=3731aef8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3731aef8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3731aef8')) {
      api.createRecord('3731aef8', component.options)
    } else {
      api.reload('3731aef8', component.options)
    }
    module.hot.accept("./AttendanceSampleConfig.vue?vue&type=template&id=3731aef8&scoped=true", function () {
      api.rerender('3731aef8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/AttendanceSampleConfig.vue"
export default component.exports